import axios from 'axios'
import applePayBase64 from '../plugins/apple_pay_base64'

export default {
  data: function () {
    return {
      applePayOrderData: null
    }
  },
  computed: {
    isShowApplePayButton () {
      console.log('isShowApplePayButton')
      console.log(window.ApplePaySession && window.ApplePaySession.canMakePayments)
      console.log('isShowApplePayButton')
      return window.ApplePaySession && window.ApplePaySession.canMakePayments
    }
  },
  methods: {
    showApplePayButton () {
      window.HTMLCollection.prototype[Symbol.iterator] = Array.prototype[Symbol.iterator]
      const button = document.getElementById('apple-pay-button')

      console.log('---------button----------')
      console.log(button)
      console.log('---------button----------')

      if (button) {
        button.className += ' visible'
      }
    },
    applePayStart (order, ePayData) {
      let session = this.$bus.applePaySession

      let applePayIs3DSTransaction = true

      /**
       * Merchant Validation
       * We call our merchant session endpoint, passing the URL to use
       */
      session.onvalidatemerchant = (event) => {
        const validationURL = event.validationURL

        axios.post(
          'https://epay.aptsys.com.sg/2c2p/apple_pay/validate_merchant',
          Object.assign({ 'validation_url': validationURL }, ePayData)
        )
          .then(response => {
            applePayIs3DSTransaction = response.data.is_3ds_transaction

            delete response.data.is_3ds_transaction

            session.completeMerchantValidation(response.data)
          })
          .catch(error => {
            console.log(error.response)
            session.abort()
          })
      }

      /**
       * Payment Authorization
       * Here you receive the encrypted payment data. You would then send it
       * on to your payment provider for processing, and return an appropriate
       * status in session.completePayment()
       */
      session.onpaymentauthorized = (event) => {
        // Send payment for processing...
        const payment = event.payment
        let requestData = JSON.stringify((payment.token.paymentData))
        let encodedString = applePayBase64.encode(requestData)

        console.log('ePayData in onpaymentauthorized')
        console.log(ePayData)
        console.log('ePayData in onpaymentauthorized')

        let url = 'https://epay.aptsys.com.sg/2c2p/apple_pay/authorized'
        let data = Object.assign({ 'payment_data': encodedString }, ePayData)

        // 如果使用3DS方式支付，则必须使用POST的网页跳转形式
        if (applePayIs3DSTransaction) {
          this.ApplePayPost3DSTransaction(data, url)
        } else {
          axios.post(
            url,
            data
          )
            .then(response => {
              let redirectUrl = ePayData.redirect_url

              console.log(response)
              switch (response.data.status) {
                case 'ERROR':
                  redirectUrl = redirectUrl + '?status=0'
                  session.completePayment(window.ApplePaySession.STATUS_FAILURE)
                  break
                case 'SUCCESS':
                  redirectUrl = redirectUrl + '?status=1&refId=' + response.data.platform_transaction_id
                  session.completePayment(window.ApplePaySession.STATUS_SUCCESS)
                  break
                default:
                  redirectUrl = redirectUrl + '?status=0'
                  session.completePayment(window.ApplePaySession.STATUS_FAILURE)
                  break
              }

              setTimeout(() => {
                window.location = redirectUrl
              }, 500)
            })
            .catch(error => {
              console.log(error)
            })
        }
      }

      session.oncancel = (event) => {
        console.log('Apple Oncancel Callback Function')
        console.log(event)
        console.log('Apple Oncancel Callback Function')

        // session.abort()

        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Apple Pay',
          text: 'Apple Pay Failed, Please Try Again Or Use Another Payment Method.',
          modal: true
        })

        this.$store.dispatch('order/resetPaymentMode')
      }

      console.log('session.begin()')
      let beginResult = session.begin()
      console.log(beginResult)
      console.log('session.begin()')
    },
    ApplePayPost3DSTransaction (data, url) {
      let form = document.createElement('form')

      form.method = 'POST'
      form.action = url

      for (const key in data) {
        let element = document.createElement('input')
        element.type = 'hidden'
        element.value = data[key]
        element.name = key
        form.appendChild(element)
      }

      let div = document.createElement('div')
      div.style.display = 'none'

      div.appendChild(form)

      document.body.appendChild(div)

      form.submit()
    },
    createApplePaySession (restaurantName, order) {
      console.log('In createApplePaySession Function Parameters')
      console.log(restaurantName)
      console.log(order)
      console.log('In createApplePaySession Function Parameters')

      let lineItems = []
      for (let i = 0; i < order.items.length; i++) {
        let item = order.items[i]
        lineItems.push({
          label: item.name,
          amount: item.final_price,
          type: 'final'
        })
      }

      let gstAmount = parseFloat(order.gst_amount)
      let svcAmount = parseFloat(order.svc_amount)
      if (gstAmount) {
        lineItems.push({
          label: 'GST Tax',
          amount: gstAmount,
          type: 'final'
        })
      }
      if (svcAmount) {
        lineItems.push({
          label: 'SVC Tax',
          amount: svcAmount,
          type: 'final'
        })
      }

      const paymentRequest = {
        countryCode: 'SG',
        currencyCode: 'SGD',
        lineItems: lineItems,
        total: {
          label: restaurantName,
          type: 'final',
          amount: order.payable_amount
        },
        supportedNetworks: ['amex', 'masterCard', 'visa', 'chinaUnionPay'],
        merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit']
      }

      return new window.ApplePaySession(3, paymentRequest)
    },
    setApplePaySession (restaurantName, order) {
      const session = this.createApplePaySession(restaurantName, order)

      this.$bus.applePaySession = session

      return session
    }
  },
  created () {
    console.log('created in apple_pay.js')
    if (window.ApplePaySession) {
      if (window.ApplePaySession.canMakePayments) {
        this.showApplePayButton()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/apple_pay.js